const axios = require('axios').default

const findCulturalItemByUuidUrl = `${process.env.API_BASE_URL}meta/culturalItems/search/findByUuid?uuid=`
export default {
  getculturalItemTitleAndImagesUuidsAndThumbLinks: (culturalItemUuid, apiClient = axios) => {
    let culturalItemTitle = ''
    return apiClient
      .get(findCulturalItemByUuidUrl + culturalItemUuid)
      .then(culturalItemResponse => {
        culturalItemTitle = culturalItemResponse.data.sgtt
        return apiClient.get(culturalItemResponse.data._links.imageLists.href)
      })
      .then(imagesListResponse =>
        apiClient.get(`${imagesListResponse.data._embedded.imageLists[0]._links.images.href}?size=10000`)
      )
      .then(imagesResponse => {
        const itemHasImages = imagesResponse.data._embedded && imagesResponse.data._embedded.images
        if (itemHasImages) {
          return {
            title: culturalItemTitle,
            imagesUuids: imagesResponse.data._embedded.images.map(image => image.uuid),
            thumbLinks: imagesResponse.data._embedded.images.map(image => image._links.thumb)
          }
        }
        return { title: culturalItemTitle, imagesUuids: [], thumbLinks: [] }
      })
  }
}
